import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const AdminAnnouncementView = () => {
    const authorizedAxios = generateAxiosInstance()
    const [InstituteGradeList, setInstituteGradeList] = useState([])
    const [modalData, setModalData] = useState('')

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [addNew, setAddNew] = useState(false);

    const [titleSort, setTitleSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["title", "content", "instituteMasterId", "sectionMasterId", "instituteMasterDetails.instituteName", "instituteMasterDetails.instituteName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getAnnouncements();
    }, []);

    const getAnnouncements = async () => {
        try {
            setLoading(true);
            let apiUrl = "/get-announcement";
            const response = await authorizedAxios.get(apiUrl);
            setInstituteGradeList(response.data.result);
        } catch (error) {
            setInstituteGradeList([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getAnnouncements();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteGradeList(await searchArray("A", "/get-announcement", searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(InstituteGradeList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(InstituteGradeList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > InstituteGradeList.length) {
            endIndex = InstituteGradeList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(InstituteGradeList.slice(startIndex, endIndex));
    }, [InstituteGradeList, currPage, itemsPerPage]);

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Admin Announcement</span></li>
                        </ol>
                    </nav>
                </div>
                <CModal
                    visible={modalData !== ''}
                    onClose={() => setModalData('')}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className='announcement-div'>
                        <div className='icon'>
                            <i class="fa fa-bullhorn"></i>
                        </div>
                        <h2 >{modalData?.title}</h2>
                        <p className='announcement-p'>{modalData?.content}</p>
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setModalData('')}>
                            Close
                        </button>
                    </div>
                </CModal>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-bullhorn"></i> Admin Announcement</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                            </div>
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Title
                                                                            <SortIcon sortState={titleSort} setSortState={setTitleSort} setData={setInstituteGradeList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">Announcement</th>
                                                                        <th scope='col'>Created By</th>
                                                                        <th scope='col'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.title}</td>
                                                                                        <td>{std.content}</td>
                                                                                        <td>{std.instituteMasterId == null && std.sectionMasterId == null ? "Admin" : std.sectionMasterId == null ? std.instituteMasterDetails.instituteName : `${std.instituteMasterDetails.instituteName}/${std.sectionMasterDetails.sectionName}`}</td>
                                                                                        <td>
                                                                                            <button className='btn btn-success approve_icon' onClick={() => setModalData(std)} >View</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: '50px' }}>No Announcement Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={InstituteGradeList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AdminAnnouncementView
